document.addEventListener("DOMContentLoaded", function () {
  jQuery('.slide_custom').slick({
    centerMode: true,
    centerPadding: '0',
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1, // keep 1 always for center mode
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: { 
          slidesToShow: 3, 
          slidesToScroll: 1, 
          centerMode: true,
          centerPadding: '40px'
        }
      },
      {
        breakpoint: 600,
        settings: { 
          slidesToShow: 1, 
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '30px'
        }
      },
      {
        breakpoint: 480,
        settings: { 
          slidesToShow: 1, 
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '20px'
        }
      }
    ]
  });
});




(function () {
  // Sirf mobile pe chalao (optional - remove karo agar sab pe chahiye)
  // if (window.innerWidth > 768) return;

  const header = document.getElementById('header-component');
  if (!header) return;

  let lastScrollY = window.scrollY;
  let ticking = false;

  function updateHeader() {
    const currentScrollY = window.scrollY;
    const scrollDiff = currentScrollY - lastScrollY;

    if (currentScrollY < 10) {
      // Top pe aa gaye — inactive
      header.setAttribute('data-sticky-state', 'inactive');
    } else if (scrollDiff < -5) {
      // Scroll UP — active
      header.setAttribute('data-sticky-state', 'active');
    } else if (scrollDiff > 5) {
      // Scroll DOWN — inactive
      header.setAttribute('data-sticky-state', 'inactive');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });

  // Initial state set karo
  updateHeader();
})();